import { useEffect } from 'react'

import {
  useBuildLocalStorageKey,
  useFilterStateDispatcher,
} from '../../contexts/filterGroupStore'
import { type GenericFilterStateReturn } from '../../types'
import { type BaseFilterProps } from '../BaseFilter'

type UseBaseFilterStateProps<T, V extends GenericFilterStateReturn<T>> = Pick<
  BaseFilterProps<T, V>,
  'filterName' | 'useFilterState' | 'toSerializableData'
>

export function useBaseFilterState<T, V extends GenericFilterStateReturn<T>>(
  props: UseBaseFilterStateProps<T, V>
) {
  const { useFilterState, toSerializableData, filterName } = props

  const dispatch = useFilterStateDispatcher()
  const buildLocalStorageKey = useBuildLocalStorageKey()
  const state = useFilterState(buildLocalStorageKey(filterName))

  useEffect(() => {
    dispatch({ filterName: filterName, filterState: state, toSerializableData })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  return state
}
